<script setup lang="ts">
import { ref, watch } from 'vue'
import { startOfMonth, lastDayOfMonth } from 'date-fns'
import { useEventStore } from '@/stores/useEventStore'
import { storeToRefs } from 'pinia'

const eventStore = useEventStore()
const { calendarAttributes, loadingEventsUser } = storeToRefs(eventStore)

// Utilisé pour forcer le rechargement du calendrier en cas de création / modification d'un événement
const calendarKey = ref(0)

watch(calendarAttributes, () => {
  calendarKey.value++
})
</script>

<template>
  <VCalendar
    v-if="!loadingEventsUser"
    :key="calendarKey"
    title-position="left"
    :attributes="calendarAttributes"
    :step="1"
    :min-date="startOfMonth(new Date())"
    :max-date="lastDayOfMonth(new Date())"
    class="w-72"
  />
  <div v-else class="skeleton h-[270px] w-[256px] opacity-70" />
</template>
